module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lecturers"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        return _vm.showEditor($event)
      }
    }
  }, [_vm._v("Előadó hozzáadása")])], 1), _vm._v(" "), _vm._l((_vm.lecturers), function(lecturer) {
    return _c('div', {
      staticClass: "lecturer-row card row between-md middle-md"
    }, [_c('span', {
      staticClass: "col-md-10"
    }, [_vm._v(_vm._s(lecturer.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.edit(lecturer)
        }
      }
    }, [_c('md-icon', [_vm._v("create")]), _c('br')], 1), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.remove(lecturer)
        }
      }
    }, [_c('md-icon', [_vm._v("remove_circle_outline")])], 1)])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d31da4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/LecturersView.vue
// module id = 550
// module chunks = 2